// src/theme.js
import { createTheme } from "@mui/material/styles";

export const getDesignTokens = (mode) => ({
  palette: {
    mode,
    ...(mode === "light"
      ? {
          primary: { main: "#1976d2" },
          secondary: { main: "#9c27b0" },
          background: { default: "#f6f8fa", paper: "#ffffff" },
        }
      : {
          primary: { main: "#90caf9" },
          secondary: { main: "#ce93d8" },
          background: { default: "#0b1220", paper: "#0f172a" },
          text: { primary: "#e5e7eb", secondary: "#94a3b8" },
        }),
  },
  shape: { borderRadius: 12 },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
      },
    },
    MuiAppBar: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        colorDefault:
          mode === "light"
            ? { backgroundColor: "#ffffff", borderBottom: "1px solid #e5e7eb" }
            : { backgroundColor: "#0f172a", borderBottom: "1px solid #1f2937" },
      },
    },
  },
});

export const makeTheme = (mode) => createTheme(getDesignTokens(mode));
